/* eslint-disable */
import React, {useState} from 'react'
import CopiedTemplate from "_assets/svg/copy_logo.svg";

// styling
import './ClipBoardCustom.scss'

function ClipSingle(props) {
  const {textValue, className, wording, icon} = props;

  const [isShowCopied, setShowCopied] = useState(false);

  function handleCopyId(value) {
    /* Copy the text inside the text field */
    navigator.clipboard.writeText(value);

    setShowCopied(true);
    setTimeout(() => {
      setShowCopied(false);
    }, 1000);
    /* Alert the copied text */
    // alert("Copied the text: " + isInfoSelected.data.template_id);
  }

  return (
    <div onClick={()=>handleCopyId(textValue)} className={`${className} wrapper_tooltipBoardCustom position-relative`}>
      <img
        src={CopiedTemplate}
        className={`${textValue && icon ? "" : "d-none"} cursor-pointer`}
        alt="copy_image" 
      />
      <span className={`${!wording && 'none' }`}>{wording}</span>
      <div className={`tooltipBoardCustom ${isShowCopied? "" : "d-none"}`}>Copied</div>
    </div>
  )
}

export default ClipSingle